export const base = {
    black: '#000000',
    black80: '#000000CC',
    black60: '#00000099',
    black40: '#00000066',
    black30: '#0000004d',
    black10: '#0000001A',
    gray: '#CCCCCC',
    lightGrey: '#F5F5F5',
    white: '#FFFFFF',
    darkCarrotOrange: '#C97500',
    carrotOrange: '#e48400',
    carrotOrange35: 'rgba(228, 132, 0, 0.35)',
    lightCarrotOrange: '#FAE6CC',
    veryLightCarrotOrange: '#FCF3E5',
    coral: '#EBA378',
    lightRed: '#F4DAD7',
    errorRed: '#D26556',
    warmGray: '#EEDDCD',
    pampas: '#F4F2EF',
    lightPampas: '#FAF9F7',
    darkGreen: '#347559',
    mint: '#C2DBCC',
    mintAlternate: '#DDEBE2',
    darkBlue: '#15415B',
    midBlue: '#417091',
    patternsBlue: '#D3DFE3',
    lightBlue: '#E0E8EA',
    // Legacy,
    darkOldRose: '#9a4856',
} as const;
